import React, { useState } from "react";
import Content from "../components/Programs/Content";
import Aside from "../modules/SideNav/Aside";

function ContentLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <Content handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default ContentLayout;
